import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';
import { COLORS } from '~/types/AppData/Theme/ColorInterface';
import { getCSSColorFill } from '~/utilities/getCSS';

const cssClasses = cva('', {
  variants: {
    color: getCSSColorFill(),
  },
});

export default component$(
  ({ color = COLORS.PRIMARY }: { color?: COLOR }): JSX.Element => {
    return (
      <svg
        class={cssClasses({ color })}
        width='8'
        height='8'
        viewBox='0 0 10 10'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g>
          <path d='M6.47615 4.93164L2.14282 0.598313L2.8095 -0.0683594L7.8095 4.93164L2.8095 9.93164L2.14282 9.26497L6.47615 4.93164Z' />
        </g>
      </svg>
    );
  }
);
